/*
  Care guide: highlights the chapter in view, scrolls the chapter bar to keep it visible on smaller screens,
  smooth-scrolls to a chapter on click, and adds the care kit to the cart without leaving the page.
*/
(() => {
  const nav = document.querySelector('[data-sok-care-nav]');
  if (!nav) return;
  const track = nav.querySelector('.sok-care__nav-track');
  const links = [...nav.querySelectorAll('a[href^="#"]')];
  const chapters = links.map((link) => document.getElementById(link.hash.slice(1)));
  let active = -1;
  let ticking = false;

  const setActive = (index) => {
    if (index === active) return;
    active = index;
    links.forEach((link, i) => {
      link.classList.toggle('is-active', i === index);
      if (i === index) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    });
    const link = links[index];
    if (link && track.scrollWidth > track.clientWidth) {
      track.scrollTo({ left: link.offsetLeft - track.clientWidth / 2 + link.offsetWidth / 2, behavior: 'smooth' });
    }
  };

  const update = () => {
    ticking = false;
    let index = 0;
    chapters.forEach((el, i) => {
      if (el && el.getBoundingClientRect().top < window.innerHeight * 0.35) index = i;
    });
    setActive(index);
  };

  window.addEventListener(
    'scroll',
    () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    },
    { passive: true }
  );
  update();

  links.forEach((link, i) =>
    link.addEventListener('click', (event) => {
      const el = chapters[i];
      if (!el) return;
      event.preventDefault();
      const offset = parseFloat(getComputedStyle(el).scrollMarginTop) || 90;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - offset, behavior: reduce ? 'auto' : 'smooth' });
      history.replaceState(null, '', link.hash);
    })
  );

  // With the cart drawer turned on, add the kit and open the drawer. Otherwise the form posts to /cart/add and
  // Shopify takes the customer to the cart page.
  document.querySelectorAll('[data-sok-care-buy]').forEach((form) =>
    form.addEventListener('submit', async (event) => {
      const drawer = document.querySelector('cart-drawer');
      if (!drawer?.renderContents) return;
      event.preventDefault();
      const button = form.querySelector('[type="submit"]');
      button.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(form.querySelector('[name="id"]').value), quantity: 1 }],
            sections: [...new Set(drawer.getSectionsToRender().map((x) => x.id))],
            sections_url: window.location.pathname,
          }),
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description);
        drawer.renderContents(result);
      } catch (e) {
        form.submit();
      } finally {
        button.removeAttribute('aria-busy');
      }
    })
  );
})();
